import { RuleResult } from '../../../../types/DeclarationP5'

const C0053Validator = {
  validateAddressRequirement: ({
    security,
  }: {
    security: string
  }) : RuleResult => (['1', '3'].includes(security) ? 'REQUIRED' : 'NOT_ALLOWED'),
}

export default C0053Validator
